module.exports = __webpack_public_path__ + "img/help.5a517ed9.svg";